import axios from "axios";
// Chapter APIs
const CHAPTER_API_URL = "api/admin/chapters";
export const getChapters = () => axios.get(CHAPTER_API_URL);
export const addChapter = (data) => axios.post(CHAPTER_API_URL, data);
export const updateChapter = (id, data) => axios.put(`${CHAPTER_API_URL}/${id}`, data);
export const deleteChapter = (id) => axios.delete(`${CHAPTER_API_URL}/${id}`);
// Topic APIs
const TOPIC_API_URL = "api/admin/topics";
export const getTopics = () => axios.get(TOPIC_API_URL);
export const addTopic = (data) => axios.post(TOPIC_API_URL, data);
export const updateTopic = (id, data) => axios.put(`${TOPIC_API_URL}/${id}`, data);
export const deleteTopic = (id) => axios.delete(`${TOPIC_API_URL}/${id}`);
// Syllabus APIs
const SYLLABUS_API_URL = "api/admin/add-syllabus";
export const addSyllabus = (data) => axios.post(SYLLABUS_API_URL, data);